import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {withStyles, Paper, Typography, Divider, IconButton, Button, colors, Drawer} from '@material-ui/core'
import Edit from '@material-ui/icons/Edit'
import AvTimer from '@material-ui/icons/AvTimer'
import Delete from '@material-ui/icons/Delete'
import Add from '@material-ui/icons/Add'

import {SubmitButton, ArrowToolTip, FormElement, PageContainer} from '../../../components/components'
import TabContainer from '../TabContainer'
import moment from 'moment/moment'

import {clearFormFields, toTitleCase} from '../../../util/misc'
import FormElementType from '../../../components/FormElement/FormElementType'
import {validations} from '../../../util/validations'
const styles = {
    downloadableSection: {
        padding: '1em',
        border: '1px solid #e0e0e0',
        borderRadius: '2px',
        marginBottom: '3em'
    },

    downloadsTitle: {
        display: 'flex',
        flex: 1,
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        paddingLeft: '0.5em'
    },

    versionNumber: {
        flex: 1
    },

    downloadableItem: {
        display: 'flex',
        flex: 1,
        flexDirection: 'row',
        alignItems: 'center',
        paddingLeft: '1em',
        paddingRight: '1em',
        borderBottom: '1px solid #e0e0e0'
    },

    red: {
        backgroundColor: colors.red[500]
    },

    lastUpdated: {
        paddingLeft: '0.5em',
        paddingRight: '0.5em'
    },

    createNewDownloadable: {
        marginTop: '0.5em',
        paddingLeft: '0.5em'
    },

    submitButton: {
        padding: '0.5em 15em 0.5em 15em',
        marginTop: '5em',
        alignSelf: 'center'
    },

    formInputsContainer: {
        width: '50%'
    },

    pageContainer: {
        display: 'flex',
        flex: 1,
        flexDirection: 'column',
        transitionDuration: '1s',
        paddingTop: '1em',
        paddingBottom: '2em'
    },

    pageInnerContainer: {
        paddingTop: '1em'
    },

    formTitle: {
        paddingBottom: '1em'
    }
}


class DownloadsEdit extends Component {
    state = {
        isDisabled: true,
        isOpen: false,
        type: null,
        editingDownload: null
    }

    onValidationChangeDetected = () => {
        const isDisabled = Object.keys(this.formInputFields).find(key => (!this.formInputFields[key].state.isValid)) !== undefined
        console.log(this.formInputFields, isDisabled)
        this.setState({isDisabled})
    }

    toggleForm = isOpen => () => {
        this.setState({isOpen})
        clearFormFields(this.formInputFields)
    }

    onAddClick = type => () => {
        this.setState({type, isOpen: true, editingDownload: null})
        clearFormFields(this.formInputFields)
    }

    onEditClick = editingDownload => () => {
        this.setState({type: editingDownload.type, isOpen: true, editingDownload})
        this.formInputFields.version.setValue(editingDownload.version)
    }

    onDeleteClick = downloadableId => () => {
        let formData = new FormData()
        formData.append('downloadable[id]', downloadableId)
        formData.append('downloadable[delete]', 1)
        this.props.editProjectDetails(this.props.projectDetails.id, formData)
    }

    onSubmitOrUpdate = () => {
        const formData = new FormData()
        if (!this.state.editingDownload) {
            formData.append('newDownloadable', this.formInputFields.file.state.value[0])
            formData.append('downloadable[version]', this.formInputFields.version.state.value)
            formData.append('downloadable[type]', this.state.type)
        } else {
            formData.append('downloadable[id]', this.state.editingDownload.id)
            formData.append('downloadableFile', this.formInputFields.file.state.value[0])
        }
        this.props.editProjectDetails(this.props.projectDetails.id, formData, this.toggleForm(false))
    }

    renderDownloadableSection = (name, pluralName, items) => {
        const {classes: styles} = this.props
        return (
            <Paper className={styles.downloadableSection} elevation={0}>
                <Typography variant="h5" color="inherit" className={styles.downloadsTitle}>
                    {pluralName}
                    <ArrowToolTip title={`Add ${name}`}>
                        <IconButton color={'primary'} onClick={this.onAddClick(name.toLowerCase())}>
                            <Add />
                        </IconButton>
                    </ArrowToolTip>
                </Typography>
                <Divider />
                {items.map((item, index) => (
                    <div key={index} className={styles.downloadableItem}>
                        <Typography variant="body2" color="inherit" className={styles.versionNumber}>
                            {item.version}
                        </Typography>
                        <AvTimer />
                        <Typography variant="body2" color="inherit" className={styles.lastUpdated}>
                            Added {moment(item.created_at).format('LL')}
                        </Typography>
                        <ArrowToolTip title={'Edit'}>
                            <IconButton color={'primary'} onClick={this.onEditClick(item)}>
                                <Edit />
                            </IconButton>
                        </ArrowToolTip>
                        <ArrowToolTip title={'Delete'} placement={'right'}>
                            <IconButton color={'secondary'} onClick={this.onDeleteClick(item.id)}>
                                <Delete />
                            </IconButton>
                        </ArrowToolTip>
                    </div>
                ))}
                <Button className={styles.createNewDownloadable} size={'small'} color={'primary'} onClick={this.onAddClick(name.toLowerCase())}>
                    Create New {name}
                </Button>
            </Paper>
        )
    }

    formInputFields = {}

    formFields = () => ([
        {label: 'Version Number', name: 'version', minLength: 1, maxLength: 50, type: 'text', required: true, validations: validations.downloadable.versionNumber},
        {label: `Drag & Drop your <span class="filepond--label-action">${this.state.type && toTitleCase(this.state.type)} files </span> or <span class="filepond--label-action"> Browse </span>`, name: 'file', required: true, elementType: FormElementType.MultiFile, filePondProps: {allowMultiple: true, maxFiles: 20, dropValidation: true}}
    ])

    render () {
        const {classes: styles, active, projectDetails} = this.props
        const {isOpen, editingDownload, isDisabled} = this.state
        const type = this.state.type ? toTitleCase(this.state.type) : ''
        const projectName = projectDetails ? projectDetails.name : ''

        return (
            <TabContainer active={active} title={'Update Downloads'}>
                {projectDetails && this.renderDownloadableSection('Release', 'Releases', projectDetails.downloads.filter(dl => dl.type === 'release'))}
                {projectDetails && this.renderDownloadableSection('Source', 'Sources', projectDetails.downloads.filter(dl => dl.type === 'source'))}
                <Drawer
                    anchor="bottom"
                    open={isOpen}
                    onClose={this.toggleForm(false)}
                    onOpen={this.toggleForm(true)}
                    keepMounted
                >

                    <PageContainer className={styles.pageContainer} containerClassName={styles.pageInnerContainer}>
                        <Typography variant="h5" color="primary" className={styles.formTitle}>
                            { editingDownload ? `Upload New ${type} for ${projectName}@v${editingDownload.version}` : `Create New ${type} for ${projectName}`}
                        </Typography>

                        {this.formFields().map((properties, index) => (
                            <FormElement key={index} {...properties} innerRef={ref => (this.formInputFields[properties.name] = ref || this.formInputFields[properties.name])} onValidationChangeDetected={this.onValidationChangeDetected} disabled={editingDownload && properties.name === 'version'} />
                        ))}

                        <SubmitButton className={styles.submitButton} isDisabled={isDisabled} onClick={this.onSubmitOrUpdate}>{editingDownload ? 'Update' : 'Submit'}</SubmitButton>
                    </PageContainer>

                </Drawer>
            </TabContainer>
        )
    }
}

DownloadsEdit.propTypes = {
    classes: PropTypes.object,
    active: PropTypes.bool,
    projectDetails: PropTypes.object
}

export default withStyles(styles)(DownloadsEdit);
